<ng-container *ngIf="!isLoading">
  <ion-row>
    <ion-col class="ion-text-center ion-margin-top">
      <ion-label class="lbl-title-estado-vazio">
        Erro ao buscar as informações!
      </ion-label>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="ion-text-center">
      <ion-text class="lbl-subtitle-estado-vazio">
        Tente novamente mais tarde <br/> ou atualize a página.
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="ion-text-center">
      <img src="../../../../assets/imgs/error-state.svg" alt="Imagem de erro." height="240"
           width="210"/>
    </ion-col>
  </ion-row>
</ng-container>

